module.exports = __webpack_public_path__ + "img/2-gallery.f13d052b.png";